import { faEye, faUsers } from "@fortawesome/free-solid-svg-icons";
import React, { useState } from "react";
import { useIntl } from "react-intl";
import { connect, useDispatch } from "react-redux";
import { approveOrRejectRegisteredUser, fetchRegisteredUsers } from "../../store/thunks/registrations";
import { showToast } from "../../store/thunks/toasts";
import InplaceProgress from "../DesignSystem/InplaceProgress/InplaceProgress";
import NoData from "../DesignSystem/NoData/NoData";
import Table from "../DesignSystem/Table/Table";
import TableItem from "../DesignSystem/Table/TableItem";

export default connect(
	(state) => ({
		...state.registrations,
	}),
	{ fetchRegisteredUsers, approveOrRejectRegisteredUser, showToast }
)(({ usersList, onClickViewUserDetails, fetchingRegisteredUsers, fetchingRegisteredUsersComplete }) => {
	const { formatMessage } = useIntl();

	const [tableButtons, setTableButtons] = useState([]);
	const [tableHeaders, setTableHeaders] = useState([
		"registration.table.header.photo",
		"registration.table.header.name",
		"registration.table.header.phoneNumber",
		"registration.table.header.age",
		"registration.table.header.region",
		"registration.table.header.city",
		"registration.table.header.reason",
		"registration.table.header.actions",
	]);
	const colWidth = 100 / tableHeaders.length;

	const getTableButtons = (data) => {
		let buttons = [
			{
				label: "view",
				icon: faEye,
				onClick: () => {
					onClickViewUserDetails(data);
				},
			},
		];

		return buttons;
	};

	return (
		<>
			{!fetchingRegisteredUsers && fetchingRegisteredUsersComplete ? (
				<>
					<div className="dashboard-content-body">
						{usersList.length ? (
							<>
								<Table headers={tableHeaders} />
								<div>
									{usersList.map((data) => {
										return (
											<div className="table-items flex direction-row align-items-center justify-content-between">
												<TableItem
													img={data.photo}
													data={``}
													styles={{ width: `${colWidth}%` }}
												/>
												<TableItem
													data={`${data.firstName} ${data.lastName}`}
													styles={{ width: `${colWidth}%` }}
												/>
												<TableItem
													data={data.mobileNumber}
													styles={{ width: `${colWidth}%` }}
												/>
												<TableItem data={data.age} styles={{ width: `${colWidth}%` }} />
												<TableItem data={data.region} styles={{ width: `${colWidth}%` }} />
												<TableItem data={data.city} styles={{ width: `${colWidth}%` }} />
												<TableItem
													data={data.reason || "N/A"}
													styles={{ width: `${colWidth}%` }}
												/>
												{tableButtons && (
													<TableItem
														data={""}
														isButtons={true}
														buttons={getTableButtons(data)}
														styles={{ width: `${colWidth}%` }}
													/>
												)}
											</div>
										);
									})}
								</div>
							</>
						) : (
							<NoData icon={faUsers} description={formatMessage({ id: "registration.nodata.message" })} />
						)}
					</div>
				</>
			) : (
				<InplaceProgress />
			)}
		</>
	);
});
